"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COPY_SONAR_OBJECT_BASE_PLURAL = exports.COPY_SONAR_OBJECT_BASE = void 0;
exports.COPY_SONAR_OBJECT_BASE = {
    APEX_CLASS: 'Apex Class',
    APEX_TRIGGER: 'Apex Trigger',
    AUTOMATION_RULE: 'Automation Rule',
    EMAIL: 'Email',
    EMAIL_ALERT: 'Email Alert',
    EMAIL_TEMPLATE: 'Email Template',
    FIELD: 'Field',
    FIELD_UPDATE: 'Field Update',
    FLOW: 'Flow',
    FORM: 'Form',
    FORMULA_FIELD: 'Formula Field',
    LANDING_PAGE: 'Landing Page',
    LIST: 'List',
    OBJECT: 'Object',
    PAGE_ACTION: 'Page Action',
    PAGE_LAYOUT: 'Page Layout',
    PICKLIST_VALUE: 'Picklist Value',
    PROCESS_BUILDER: 'Process Builder',
    PROFILE: 'Profile',
    REPORT: 'Report',
    TAG: 'Tag',
    VALIDATION_RULE: 'Validation Rule',
    WORKFLOW_ACTION: 'Workflow Action',
    WORKFLOW_RULE: 'Workflow Rule'
};
exports.COPY_SONAR_OBJECT_BASE_PLURAL = {
    APEX_CLASS: `${exports.COPY_SONAR_OBJECT_BASE.APEX_CLASS}es`,
    APEX_TRIGGER: `${exports.COPY_SONAR_OBJECT_BASE.APEX_TRIGGER}s`,
    AUTOMATION_RULE: `${exports.COPY_SONAR_OBJECT_BASE.AUTOMATION_RULE}s`,
    EMAIL: `${exports.COPY_SONAR_OBJECT_BASE.EMAIL}s`,
    EMAIL_ALERT: `${exports.COPY_SONAR_OBJECT_BASE.EMAIL_ALERT}s`,
    EMAIL_TEMPLATE: `${exports.COPY_SONAR_OBJECT_BASE.EMAIL_TEMPLATE}s`,
    FIELD: `${exports.COPY_SONAR_OBJECT_BASE.FIELD}s`,
    FIELD_UPDATE: `${exports.COPY_SONAR_OBJECT_BASE.FIELD_UPDATE}s`,
    FLOW: `${exports.COPY_SONAR_OBJECT_BASE.FLOW}s`,
    FORM: `${exports.COPY_SONAR_OBJECT_BASE.FORM}s`,
    FORMULA_FIELD: `${exports.COPY_SONAR_OBJECT_BASE.FORMULA_FIELD}s`,
    LANDING_PAGE: `${exports.COPY_SONAR_OBJECT_BASE.LANDING_PAGE}s`,
    LIST: `${exports.COPY_SONAR_OBJECT_BASE.LIST}s`,
    OBJECT: `${exports.COPY_SONAR_OBJECT_BASE.OBJECT}s`,
    PAGE_ACTION: `${exports.COPY_SONAR_OBJECT_BASE.PAGE_ACTION}s`,
    PAGE_LAYOUT: `${exports.COPY_SONAR_OBJECT_BASE.PAGE_LAYOUT}s`,
    PICKLIST_VALUE: `${exports.COPY_SONAR_OBJECT_BASE.PICKLIST_VALUE}s`,
    PROCESS_BUILDER: `${exports.COPY_SONAR_OBJECT_BASE.PROCESS_BUILDER}s`,
    PROFILE: `${exports.COPY_SONAR_OBJECT_BASE.PROFILE}s`,
    REPORT: `${exports.COPY_SONAR_OBJECT_BASE.REPORT}s`,
    TAG: `${exports.COPY_SONAR_OBJECT_BASE.TAG}s`,
    VALIDATION_RULE: `${exports.COPY_SONAR_OBJECT_BASE.VALIDATION_RULE}s`,
    WORKFLOW_ACTION: `${exports.COPY_SONAR_OBJECT_BASE.WORKFLOW_ACTION}s`,
    WORKFLOW_RULE: `${exports.COPY_SONAR_OBJECT_BASE.WORKFLOW_RULE}s`
};
//# sourceMappingURL=SONAR_OBJECTS.js.map